import React, { ReactNode, useContext, useEffect, useState } from 'react'
import { AccountBean } from 'src/api/api'
import { StorageKey } from 'src/util/Storage'
import RoleEnum = AccountBean.RoleEnum

export interface User {
    id: number,
    email: string,
    role: RoleEnum,
    publisherId?: number,
    dspId?: number
}

const Context = React.createContext<{
    user: User | undefined,
    setUser: (user: User) => void,
    blackTheme: Boolean | undefined,
    setBlackTheme: (black: Boolean) => void
} | undefined
>(undefined)

export const useUser = () => {
    const context = useContext(Context)
    if (!context) {
        throw new Error('useUser must be used within a UserProvider')
    }
    return context
}

const UserProvider: React.FC = (props: { children: ReactNode }) => {

    const [user, setUser] = useState<User>()
    const [blackTheme, setBlackTheme] = useState<Boolean>()

    useEffect(() => {
        const isBlack = localStorage.getItem(StorageKey.BlackThemeEnabled)
        setBlackTheme('true' == isBlack)
    }, [])

    return (
        <Context.Provider value={{ user, setUser, blackTheme, setBlackTheme }}>
            {props.children}
        </Context.Provider>
    )
}

export default UserProvider


// WEBPACK FOOTER //
// ./src/context/UserContext.tsx